module.exports = __webpack_public_path__ + "static/media/img_成功.e42cb127.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_成功.svg
// module id = 375
// module chunks = 0